module.exports = __webpack_public_path__ + "static/media/DSC07457.78c91814.JPG";